export default "__VITE_ASSET__BoaMCLWH__"